import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiCronComponent } from '@components/ui-cron/ui-cron.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';

@NgModule({
    imports: [
        CommonModule,
        UiSuggestModule,
        ComponentSharedModule,
        MatRadioModule,
        MatIconModule,
        TranslateModule,
        MatInputModule,
        MatCheckboxModule,
    ],
    declarations: [
        UiCronComponent,
    ],
    exports: [
        UiCronComponent,
    ],
})
export class UiCronModule { }
